import React, { ReactNode } from "react";

import "./header.css";

export const Header = ({ left, right }: { left?: ReactNode; right?: ReactNode }) => (
	<header className="header">
		{left && <div className="header__left">{left}</div>}
		{right && <div className="header__right">{right}</div>}
	</header>
);
Header.displayName = "Header";
